import View from './View'
import MenuButton from './MenuButton'
import AboutButton from './AboutButton'
import { ease } from './helpers/EaseHelper'
import { addClass, removeClass, createDOM, updateSpriteSheet } from './helpers/DOMHelper'

const STATE_OPEN = 'menu-open'
const STATE_CLOSE = 'menu-close'

class Menu extends View {
  constructor(el, buttons = [], toggleButton) {
    super(el)
    this._selected = 0
    this._debug = false
    this._hide = false
    this.root = document.querySelector('#root')
    this.toggleButton = new MenuButton(toggleButton)
    this.aboutButton = new AboutButton(createDOM('a', 'button menu__about'))
    this.aboutButtonTimeout = null
    this.buttons = []
    this.onSelect = () => {}
    this.onToggleMenu = () => {}
    this.view.innerHTML = ''
    this.buildButtons(buttons)
    this.toggleButton.view.addEventListener('click', () => this.toggleMenu())
  }

  get selected () { return this._selected }
  set selected (value) {
    this.buttons[this._selected].className = 'menu__button'
    this.buttons[value].className = 'menu__button menu__button--selected'
    this._selected = value
  }

  get hide () { return this._hide }
  set hide (value) {
    if (value) {
      this.toggleButton.hide()
    } else {
      this.toggleButton.show()
    }
    this._hide = value
  }

  get isOpen () {
    return this.state === STATE_OPEN
  }

  get debug () { return this._debug }
  set debug (value) {
    this._debug = value
    if (value) {
      addClass(this.view, 'menu--debug')
      this.toggleButton.state = 'menu-button--debug'
    } else {
      removeClass(this.view, 'menu--debug')
      this.toggleButton.state = ''
    }
  }

  buildButtons (buttons) {
    const footer = createDOM('div', 'menu__footer')
    const button = (label, id) => {
      const button = createDOM('button', 'menu__button')
      const br = createDOM('br')
      const title = createDOM('span', 'menu__title text__menu-name', label)
      const subtitle = createDOM('span', 'menu__subtitle text__menu-index', `${id + 1}`)
      const cross = createDOM('div', 'menu__subtitle-cross')
      const frameOver = 19
      const frameOut = 40

      const easeOver = () => {
        ease({ value: 0 })
        .to({ value: frameOver }, 500)
        .onUpdate(o => updateSpriteSheet(cross, '104px', o.value))
        .start()
      }

      const easeOut = () => {
        ease({ value: frameOver })
        .to({ value: frameOut }, 500)
        .onUpdate(o => updateSpriteSheet(cross, '104px', o.value))
        .start()
      }

      subtitle.appendChild(cross)
      button.appendChild(title)
      button.appendChild(br)
      button.appendChild(subtitle)
      button.addEventListener('click', () => { this.onClick(id) })
      button.addEventListener('mouseover', easeOver)
      button.addEventListener('mouseout', easeOut)
      return button
    }
    const addButton = (label, id) => {
      const bt = button(label, id)
      this.view.appendChild(bt)
      this.buttons.push(bt)
    }
    buttons.map(addButton)

    footer.appendChild(this.aboutButton.view)
    this.view.appendChild(footer)

    this.selected = 0
  }

  toggleMenu (auto=true) {
    if (this.isOpen) {
      this.state = STATE_CLOSE
      removeClass(this.root, 'menu')
      clearTimeout(this.aboutButtonTimeout)
      if (auto) this.toggleButton.show()
      this.aboutButton.hide()
      this.onToggleMenu(false)
    } else {
      this.state = STATE_OPEN
      addClass(this.root, 'menu')
      if (auto) this.toggleButton.hide()
      this.aboutButtonTimeout = setTimeout(() => { this.aboutButton.show() }, 3000)
      this.onToggleMenu(true)
    }
  }

  onClick (id) {
    if (this.isOpen) this.toggleMenu(false)
    this.selected = id
    this.onSelect(id)
  }

}
export default Menu


// WEBPACK FOOTER //
// ./src/scripts/Menu.js